/**
 * defa.routers.UserRouter
 * The Router for the UserController, all front end urls starting with /accounts/.
 * @version 1.2.0
 */

const UserRouter = Mn.AppRouter.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	appRoutes: {
		
		// login related
		'accounts/forgot-password(/)': 'showForgotPassword',
		'accounts/login/create(/)'   : 'showLoginCreate',
		'accounts/login(/)'          : 'showLogin',
		'accounts/login/:email(/)'   : 'showLogin',
		'accounts/logout(/)'         : 'showLogout',
		'accounts/new(/)'            : 'showCreate',
		'accounts/thank-you(/)'      : 'showThankYou',
		
		// specials
		'accounts/password/:token(/)': 'showNewPassword',
		'accounts/email/:token(/)'   : 'showVerifyEmail',
		
		// main
		'accounts/:id(/)'         : 'showUserPanel',
		'accounts/:id/language(/)': 'showLanguage',
		'accounts/:id/password(/)': 'showPassword',
		'accounts/:id/email(/)'   : 'showEmail',
		
		// phones
		'accounts/:id/phone-numbers(/)'               : 'showPhoneList',
		'accounts/:id/phone-numbers/create(/)'        : 'showPhoneCreate',
		'accounts/:id/phone-numbers/:number(/)'       : 'showPhoneUpdate',
		'accounts/:id/phone-numbers/:number/delete(/)': 'showPhoneDelete',
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default UserRouter;
	